import React from 'react';
import { PricingContent } from './PricingContent';
import { PricingCards } from './PricingCards';
import { EmployerLayout } from './EmployerLayout';

export const PricingPlans = () => {
  return (
    <EmployerLayout>
      <div className="flex flex-col w-full gap-8">
        <PricingContent />
        <PricingCards />
      </div>
    </EmployerLayout>
  );
};
